import { Component, OnInit, OnDestroy, Input, PipeTransform, Pipe, ChangeDetectorRef, ElementRef, HostListener } from '@angular/core';
import { UsersService } from '../../_services/users.service';

import { IuserInformation } from '../../_types/userInterfaces.type';

import { UntypedFormGroup, FormControl, UntypedFormBuilder, Validators } from '@angular/forms';





@Component({
    selector: 'manual-password-reset',
    templateUrl: './manualPasswordReset.component.html',
    styleUrls: ['./manualPasswordReset.component.css'],
})

export class ManualPasswordResetModalComponent implements OnInit, OnDestroy {
  public submitted: boolean = false;
  public manualPasswordReset: string = "";
  public passwordType: string = "text";
  public manualPasswordRestError: boolean = false;
  public manualPasswordAlertClass: string = "alert";
  public newPasswordFrm: UntypedFormGroup;
  public vm: this = this;

  @Input() public UserPasswordReset: IuserInformation = <IuserInformation>{};
  constructor(private UserService: UsersService, private fb: UntypedFormBuilder) {

    this.newPasswordFrm = fb.group({
      'new-password': ["", Validators.compose([this.passwordValidator.bind(this), Validators.required])],
      'repeat-password': ["", Validators.compose([this.passwordValidator.bind(this), Validators.required])],
      'show-password': false
    });
  }

  ngOnDestroy() {

  }

  ngOnInit() {
    this.passwordType = "password";
  }

  modalLostFocus() {
    let element = document.getElementById('passwordmodal');
    this.resetForm('passwordmodal', this.newPasswordFrm);
  }

  passwordValidator(control: any) {
    if (control.value) {
      const matches = control.value.match('(?=\S*)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}');
      return (matches && control.value.indexOf(" ") == -1) ? null : { 'invalidEmail': true };
    }

    return null;
  }

  resetForm(divName: string, form: any) {
    if (form != null) {
      form.reset({
        'new-password': "",
        'repeat-password': "",
        'show-password': false
      });
    }
    else {
      (<HTMLFormElement>document.getElementById("passwordmodalform")).reset();
    }
    switch (divName) {
      case "passwordmodal":
        this.manualPasswordAlertClass = "alert";
        this.manualPasswordReset = "";
        this.passwordType = "password";
        break;
    }
  }

  matchPassword() {
    if (this.newPasswordFrm.controls['new-password'].value == this.newPasswordFrm.controls['repeat-password'].value) {
      return false;
    }
    return true;
  }

  resetpasswordmanual() {
    this.submitted = true;
    let username = this.UserPasswordReset.username;
    if (this.newPasswordFrm.controls["new-password"].value === this.newPasswordFrm.controls["repeat-password"].value) {
      this.UserService.setUserPasswordReset(username, String(this.newPasswordFrm.controls["new-password"].value).trim(), false)
        .subscribe(result => {
          this.submitted = false;
          this.manualPasswordAlertClass = "alert alert-success"
          this.manualPasswordReset = result
        },
          error => {
            this.submitted = false;
            this.manualPasswordAlertClass = "alert alert-danger"
            this.manualPasswordReset = error;
          })
    }
    else {
      this.submitted = false;
      this.manualPasswordAlertClass = "alert alert-danger"
      this.manualPasswordReset = "Please make sure both passwords match."

    }

  }

  showPassword(obj: any) {
    if (this.passwordType == "password") {
      this.passwordType = "text";
    }
    else {
      this.passwordType = "password";
    }
  }

} 

